module.exports = __webpack_public_path__ + "static/media/isb.ff7ab483.png";